import React, { Component } from 'react';
import { PageHeader } from 'antd';

import { ClientsList } from '@containers/clients';

class ClientsPage extends Component {
  render() {
    return (
      <div className="clients main-page">
        <PageHeader
          title="Clients"
          style={{
            border: '1px solid rgb(235, 237, 240)'
          }}
        />
        <ClientsList />
      </div>
    );
  }
}

export default ClientsPage;
